import React, { useState } from 'react'
import { Button, Theme, withStyles } from '@material-ui/core'
import { Form } from '../Common'
import { updateContactForm } from '../../actions' 
import { connect } from 'react-redux'
import { IContact } from '../../api'
import { InsuranceType } from '../../helpers/insurance'
import ContactFormDialog from '../ContactForm/ContactFormDialog'

const styles = (theme: Theme) =>({
    title:{
        color: 'white',
        fontSize: theme.typography.h1.fontSize,
        fontWeight: theme.typography.h1.fontWeight,
        [theme.breakpoints.down('xs')]:{
            fontSize:'2em',
        }
    },
    subTitle:{
        marginTop:0,
        color: 'white',
        [theme.breakpoints.down('xs')]:{
            fontSize:'1em',
        }
    },
    button:{
        fontSize: '1.2em', 
        marginTop: 2,
        padding: 0,
        marginLeft: 40,
        marginRight: 40,
        minWidth: 260,
        backgroundColor: 'white',
        color: '#165372',
        borderRadius: 10,
        border: '5px solid white',
        "&:hover": {
            backgroundColor: '#467E99',
            color: 'white'
          },
        [theme.breakpoints.down('xs')]:{
            marginLeft:0,
            marginRight:0,
        }
    }
})

interface Classes {
    title: string
    subTitle: string
    button: string
}

interface Props{
    classes: Classes
    insurance?: InsuranceType
    updateContactForm: (contactForm: IContact) => void
}

const InsuranceSelectionForm = (props: Props) =>{
    const { classes, insurance, updateContactForm } = props
    const [showContactFormDialog, setShowContactFormDialog] = useState(false);
    const [selectedInsurance, setSelectedInsurance] = useState(insurance);
    return(
        <Form noValidate>
            <h1 className={classes.title}>{`מעוניינים בהשוואת`}<br/>{`ביטוחים?`}</h1>
            <h2 className={classes.subTitle}>{`השוו באופן מיידי בתחומים:`}</h2>
            {(!insurance || (insurance === 'life_insurance')) && 
            <Button className={classes.button} variant='contained' color='primary' type='button'
                onClick={() => {
                    updateContactForm({ insuranceType: 'life_insurance' });
                    setSelectedInsurance('life_insurance')
                    setShowContactFormDialog(true);
                }}>
                ביטוח חיים
            </Button>}
            {(!insurance || (insurance === 'health_insurance')) && 
            <Button className={classes.button} variant='contained' color='primary' type='button'
                onClick={() => {
                    updateContactForm({ insuranceType:'health_insurance' });
                    setSelectedInsurance('health_insurance')
                    setShowContactFormDialog(true);
                }}>
                ביטוח בריאות
            </Button>}
            {(!insurance || (insurance === 'personal_accidents_insurance')) && 
            <Button className={classes.button} variant='contained' color='primary' type='button'
                onClick={() => {
                    updateContactForm({ insuranceType:'personal_accidents_insurance' });
                    setSelectedInsurance('personal_accidents_insurance')
                    setShowContactFormDialog(true);
                }}>
                ביטוח תאונות אישיות
            </Button>}
            {(!insurance || (insurance === 'loss_of_work_fitness_insurance')) && 
            <Button className={classes.button} variant='contained' color='primary' type='button'
                onClick={() => {
                    updateContactForm({ insuranceType:'loss_of_work_fitness_insurance' });
                    setSelectedInsurance('loss_of_work_fitness_insurance')
                    setShowContactFormDialog(true);
                }}>
                ביטוח אובדן כושר עבודה
            </Button>}
            {(!insurance || (insurance === 'severe_illness_insurance')) && 
            <Button className={classes.button} variant='contained' color='primary' type='button'
                onClick={() => {
                    updateContactForm({ insuranceType:'severe_illness_insurance' });
                    setSelectedInsurance('severe_illness_insurance')
                    setShowContactFormDialog(true);
                }}>
                ביטוח מחלות קשות
            </Button>}
            <ContactFormDialog insurance={selectedInsurance} open={showContactFormDialog} onClose={() => {
                setShowContactFormDialog(false);
                }}/>
            <p className={classes.subTitle} style={{marginTop:20}}>{`בדיקת ביטוחים קיימים`}<br/>{`כולל ניתוח תיק מקיף ע"י המומחים שלנו.`}</p>
            <h2 className={classes.subTitle}>{`למידע נוסף:`}</h2>
            <h3 className={classes.subTitle} style={{marginTop:0}}>{`052-897-5001`}</h3>
        </Form>
    )
}

const InsuranceSelectionFormWithStyles = withStyles(styles)(InsuranceSelectionForm)
export default connect(null, { updateContactForm })(InsuranceSelectionFormWithStyles)